import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const PublishingWorkshops = () => <EventCategoryPage config={EVENT_CATEGORIES['publishing-workshops']} data-id="element-9186" data-mp="2mp6q6oop6dq0" />;
export default PublishingWorkshops;